import { CellContext } from '@tanstack/react-table';

import { Flex } from 'shared_DEPRECATED/components/Flex';

import { ParticipantsTableEmptyCell } from 'features/participants/components/Table';
import { ParticipantsTableRowDataType } from 'features/participants/config/types';

import { Badge } from 'shared/components/Badge';
import { Typography } from 'shared/components/Typography';

export const CurrentWeekCell = ({
  row,
  getValue,
}: CellContext<ParticipantsTableRowDataType, number>) => {
  const currentWeekNumber = getValue();
  const { latestSprint } = row.original as unknown as {
    latestSprint: {
      weekLabelForSprintDate: string;
    } | null;
  };
  const hasWeekNumber = currentWeekNumber > 0;

  return latestSprint ? (
    <Flex>
      <Badge colorPalette={hasWeekNumber ? 'lightBlue' : 'gray'} size="sm">
        <Typography
          as="span"
          type="small"
          color={hasWeekNumber ? 'blue' : 'black'}
          fontWeight="regular"
          dataTestid="participant-sprint-week"
        >
          {latestSprint.weekLabelForSprintDate}
        </Typography>
      </Badge>
    </Flex>
  ) : (
    <ParticipantsTableEmptyCell dataTestid="participant-sprint-week" />
  );
};
